var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.tasks
        ? [
            _c("strong", [_vm._v("Тип подзадачи:")]),
            _vm._v(" "),
            _c("Select", {
              attrs: {
                name: "subtaskType",
                items: _vm.tasks,
                active: _vm.active,
              },
              on: { selectChange: (v) => _vm.$emit("typeChange", v) },
            }),
          ]
        : _c("div", [_vm._v("Не созданы типы подзадач в настройках проекта")]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }